const companyService = require('./companyService')

const state = {
  companies: [],
  isCompaniesLoading: false,
}

const getters = {
  companies: (state) => state.companies,
  isCompaniesLoading: (state) => state.isCompaniesLoading,
}

const actions = {
  async searchCompanies({ commit }, term = '') {
    commit('setIsCompaniesLoading', true)
    try {
      const { data } = await companyService.listCompanies({ search: term })
      const raw = Array.isArray(data) ? data : (data?.result ?? [])
      commit('setCompanies', raw?.result ?? raw)
    } catch (_e) {
      commit('setCompanies', [])
    } finally {
      commit('setIsCompaniesLoading', false)
    }
  },
}

const mutations = {
  setCompanies: (state, list) => {
    state.companies = Array.isArray(list) ? list : []
  },
  setIsCompaniesLoading: (state, val) => {
    state.isCompaniesLoading = !!val
  },
}

export default { state, getters, actions, mutations }
